import React, { useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import apiFetch from '../../../utils/apiFetch';
import { HUNTERS_PREY_OPTIONS, getHuntersPrey, canChangeHuntersPrey, DEFENSIVE_TACTICS_OPTIONS, getDefensiveTactics, canChangeDefensiveTactics } from '../../../shared/rules/subclasses/ranger/huntersPrey.mjs';

/** A Hunter choice that can be swapped after each Short or Long Rest, saved at `classState.ranger.<stateKey>`. */
function HunterRestChoice({ form, characterId, onCharacterChange, label, stateKey, route, bodyKey, options, getChoice, canChange }) {
  const current = getChoice(form);
  const [selected, setSelected] = useState(current?.id || options[0].id);
  const [saving, setSaving] = useState(false), [error, setError] = useState('');
  const [saved, setSaved] = useState(null);
  const effective = saved ? { ...form, classState: { ...form.classState, ranger: { ...form.classState?.ranger, [stateKey]: saved } } } : form;
  const locked = !canChange(effective);
  const unchanged = getChoice(effective)?.id === selected;
  const choose = async () => {
    if (saving) return;
    setSaving(true); setError('');
    try {
      const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/classes/ranger/${route}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ [bodyKey]: selected }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || `Could not save ${label}.`);
      setSaved(result[stateKey]);
      onCharacterChange?.(previous => ({ ...previous, classState: { ...previous.classState, ranger: { ...previous.classState?.ranger, [stateKey]: result[stateKey] } } }));
    } catch (failure) { setError(failure.message); }
    finally { setSaving(false); }
  };
  return <div className="fighting-style-chooser">
    <p className="feature-sheet-hint">{locked
      ? 'You can switch to the other option after your next Short or Long Rest.'
      : current || saved ? 'You can switch options now; after that, the next change waits for another rest.' : 'Choose one option. You can switch after a Short or Long Rest.'}</p>
    {error && <Alert variant="danger">{error}</Alert>}
    {saved && <Alert variant="success">{label} saved.</Alert>}
    <Form.Label htmlFor={`ranger-${route}`}>{label}</Form.Label>
    <Form.Select id={`ranger-${route}`} value={selected} disabled={saving || locked} onChange={event => setSelected(event.target.value)}>
      {options.map(option => <option key={option.id} value={option.id}>{option.name}</option>)}
    </Form.Select>
    <p className="fighting-style-description">{options.find(option => option.id === selected)?.summary}</p>
    <div className="fighting-style-actions"><Button size="sm" onClick={choose} disabled={saving || locked || unchanged}>{saving ? 'Saving…' : `Save ${label}`}</Button></div>
  </div>;
}

/** Hunter 3: choose Colossus Slayer or Horde Breaker. */
export default function HuntersPreyChooser(props) {
  return <HunterRestChoice {...props} label="Hunter's Prey" stateKey="huntersPrey" route="hunters-prey" bodyKey="preyId"
    options={HUNTERS_PREY_OPTIONS} getChoice={getHuntersPrey} canChange={canChangeHuntersPrey}/>;
}

/** Hunter 7: choose Escape the Horde or Multiattack Defense. */
export function DefensiveTacticsChooser(props) {
  return <HunterRestChoice {...props} label="Defensive Tactics" stateKey="defensiveTactics" route="defensive-tactics" bodyKey="tacticId"
    options={DEFENSIVE_TACTICS_OPTIONS} getChoice={getDefensiveTactics} canChange={canChangeDefensiveTactics}/>;
}
